import React from "react";
import { Link } from "react-router-dom";
import PageShell from "../components/PageShell";
import { giftBoxes } from "../mock";
import { ArrowRight } from "lucide-react";

export default function PersonalizedGifts() {
  return (
    <PageShell kicker="Personalized Gifts" title="Personalized products and gifts" subtitle="Gifts built to encourage — Scripture, prayer prompts and a personal message from you.">
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {giftBoxes.map((g) => (
          <Link to="/custom-design" key={g.id} className="group block bg-white rounded-2xl overflow-hidden hover-lift border border-[color:var(--dms-navy)]/5 relative">
            {g.sale && <span className="absolute top-4 left-4 z-10 bg-[color:var(--dms-peach)] text-[color:var(--dms-navy)] text-[10px] tracking-widest font-bold px-3 py-1 rounded-full uppercase">Sale</span>}
            <div className="aspect-square overflow-hidden bg-[color:var(--dms-peach-light)]/30">
              <img src={g.img} alt={g.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
            </div>
            <div className="p-5">
              <p className="kicker text-[11px]">{g.category}</p>
              <h3 className="font-serif text-xl mt-2 text-[color:var(--dms-navy)] leading-snug">{g.title}</h3>
              <p className="mt-1 text-xs text-[color:var(--dms-navy)]/55">{g.note}</p>
              <p className="mt-3 font-serif text-2xl text-[color:var(--dms-navy)]">
                {g.price} {g.oldPrice && <span className="text-sm text-[color:var(--dms-navy)]/40 line-through ml-2">{g.oldPrice}</span>}
              </p>
              <div className="mt-5 w-full py-3 rounded-full border border-[color:var(--dms-navy)]/20 text-[11px] tracking-[0.18em] uppercase font-semibold text-[color:var(--dms-navy)] text-center group-hover:bg-[color:var(--dms-navy)] group-hover:text-white group-hover:border-[color:var(--dms-navy)] transition-colors">
                View product
              </div>
            </div>
          </Link>
        ))}
      </section>

      <section className="bg-[color:var(--dms-navy)] py-16">
        <div className="max-w-3xl mx-auto text-center px-5">
          <h2 className="font-serif text-3xl md:text-4xl text-white">Making it for someone specific?</h2>
          <p className="mt-4 text-white/75">Tell us who it's for and what you'd like it to say. We'll design around it and send you a proof first.</p>
          <div className="mt-8"><Link to="/custom-design" className="btn-peach">Start my custom design <ArrowRight className="w-4 h-4" /></Link></div>
        </div>
      </section>
    </PageShell>
  );
}
